import { forwardRef, useState } from "react";
import { IconButton, InputAdornment, TextFieldProps } from "@mui/material";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import { Input } from "../Input";

export const Password = forwardRef<any, TextFieldProps>(
  ({ ...restProps }, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    return (
      <Input
        ref={ref}
        type={showPassword ? "text" : "password"}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end" sx={{ mr: 1 }}>
                <IconButton
                  onClick={() => setShowPassword((prev) => !prev)}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
            ...restProps.slotProps?.input,
          },
          ...restProps.slotProps,
        }}
        {...restProps}
      />
    );
  },
);

export default Password;
